import { Grid, Typography } from "@mui/material";
import type { FC } from "react";
import { Fragment } from "react";
import { AssociatedFilesView } from "../../components/associatedFiles/AssociatedFilesView";
import Email from "../../components/links/Email";
import EntityCard from "../../components/entityCard/EntityCard";
import Phone from "../../components/links/Phone";
import SimpleNotes from "../../components/notes/SimpleNotes";
import { useUpdateProviderNotes } from "./useUpdateProviderNotes";
import { LastNotes } from "../../components/entityCard/LastNotes";

interface Provider {
  id: string;
  name: string;
  contacts: {
    phone?: string;
    email?: string;
  }[];
  files?: { name: string; url: string }[];
  notes?: { text: string; author: string; date: string }[];
}

interface Props {
  readonly value: Provider;
  readonly onClick: () => void;
  readonly onContextMenu: () => void;
}

const ProviderCard: FC<Props> = ({ value, onClick, onContextMenu }) => {
  const { updateNotes: updateProviderNotes } = useUpdateProviderNotes(value.id);
  return (
    <EntityCard
      role="ADMIN"
      onClick={onClick}
      onContextMenu={onContextMenu}
      rightHandSideComponent={<LastNotes notes={value.notes ?? []} />}
      rightHandSideComponentExpandable
      rightHandSideComponentSize={3}
      expandableComponent={
        <SimpleNotes
          notes={value.notes ?? []}
          onChange={async (notes) => {
            await updateProviderNotes(notes);
          }}
        />
      }
    >
      <Grid size={3}>
        <Typography variant="subtitle1">{value.name}</Typography>
      </Grid>
      <Grid size={9} container spacing={1}>
        <Grid size={12} container spacing={1}>
          {value.contacts?.map((c, index) => (
            <Fragment key={`${c.email ?? ""}-${c.phone ?? ""}-${index}`}>
              <Grid size={6}>{c.email && <Email value={c.email} />}</Grid>
              <Grid size={6}>{c.phone && <Phone value={c.phone} />}</Grid>
            </Fragment>
          ))}
        </Grid>
        <Grid size={12}>
          <AssociatedFilesView values={value.files ?? []} />
        </Grid>
      </Grid>
    </EntityCard>
  );
};

export default ProviderCard;
